import { defineComponent, h } from 'vue';
import { QCard, QCardSection, QCardActions, QToolbar, QToolbarTitle, QBtn, QInput, QIcon, QSpace } from 'quasar';
import EventBus from '../../event-bus.js';
import utils from '../../../Shared/utils.jsx';

export default defineComponent({
    name: 'usercontrol-browser',
    components: { QCard, QCardSection, QCardActions, QToolbar, QToolbarTitle, QBtn, QInput, QIcon, QSpace },
    data: () => ({
        list: [],
        filter: '',
    }),
    props: {
        confirm: null,
        cancel: null,
    },
    created() {
    },
    mounted() {
        this.Refresh();
    },
    methods: {
        async Refresh() {
            this.list = await utils.api.get('Apps/UserControls/List');
        },
        returnControl(id, title) {
            this.confirm(id, title);
        },
        search(value) {
            this.filter = value;
        },
    },
    render() {
        let items;
        if (this.list.length > 0)
            items = this.list.filter(c => (!this.filter || c.Name.toLowerCase().includes(this.filter.toLowerCase()))).map(c => (
                <tr>
                    <td><span style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }} onClick={() => this.confirm(c.Name)}>{c.Name}</span></td>
                </tr>
            ));
        else
            items = <tr><td>Loading...</td></tr>;

        return (
            <QCard style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
                <QToolbar class="bg-primary text-white" style={{ minHeight: '60px' }}>
                    <QToolbarTitle class="text-white">User Controls</QToolbarTitle>
                    <QSpace />
                    <QBtn flat dense icon="mdi-refresh" color="white" onClick={() => this.Refresh()} />
                    <QBtn flat dense icon="mdi-close-box" color="white" onClick={this.cancel} />
                </QToolbar>

                <QCardSection>
                    <QInput
                        label="Search"
                        outlined
                        dense
                        hide-bottom-space
                        clearable
                        autocomplete="off"
                        modelValue={this.filter}
                        onUpdate:modelValue={(value) => this.search(value)}
                        vSlots={{ prepend: () => <QIcon name="mdi-magnify" /> }}
                    />
                </QCardSection>
                <QCardSection style={{ minHeight: "450px", maxHeight: "450px", minWidth: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                    <table style={{ width: '100%' }}>
                        {items}
                    </table>
                </QCardSection>
                <QCardActions align="right">
                    <QSpace />
                    <QBtn flat color="green-8" onClick={this.cancel}>Cancel</QBtn>
                </QCardActions>
            </QCard>
        );
    }
});